import {ExecutionStatus, RuntimeMode} from 'constants/dataEnum';
import {useSelector} from 'react-redux';
import PropTypes from 'prop-types';
import {getRuntimeStatus} from 'stores/selectors/runtimeSelector';
import TaskWrapper from 'contents/ProtocolEditor/TaskList/Task/Components/TaskWrapper';
import TaskNumber from 'contents/ProtocolEditor/Components/TaskNumber';
import TaskTitle from 'contents/ProtocolEditor/TaskList/Task/Components/TaskTitle';
import TaskAction from 'contents/ProtocolEditor/TaskList/Task/Components/TaskAction';
import TaskPipettingProfileWrapper from 'contents/ProtocolEditor/TaskList/Task/Components/TaskPipettingProfileWrapper';
import Spinner from 'components/Spinner/Spinner';
import TaskExecutedTick from 'components/TaskExecutedTick';
import {useEffect, useState} from 'react';
import PoolingTaskDescription from './TaskDescription/PoolingTaskDescription';
import PoolingPipettingProfile from './PoolingPipettingProfile';

function PoolingTaskTransfer({
  disableDrag,
  executionStatus,
  isHighlighted,
  labware,
  labwareState,
  number,
  readOnly,
  runtimeMode,
  showEditButton,
  tasks,
  onEdit,
  onShowMenuContext,
}) {
  const runtimeStatus = useSelector(getRuntimeStatus);
  const [transferName, setTransferName] = useState('');

  useEffect(() => {
    switch (number) {
      case 1:
        setTransferName('Source well(s)');
        break;

      case 2:
        setTransferName('Sources aspirate volume');
        break;

      case 3:
        setTransferName('Destination well(s)');
        break;

      default:
        break;
    }
  }, [number]);
  const isShowPipettingProfile =
    !readOnly &&
    ((runtimeMode && runtimeStatus === RuntimeMode.PAUSED && executionStatus === ExecutionStatus.NONE) || !runtimeMode);

  return (
    <TaskWrapper disableDrag={disableDrag} isSelected={isHighlighted} onContextMenu={onShowMenuContext}>
      <TaskNumber number={number} isHighlighted={isHighlighted} />
      <TaskTitle
        title={`Pooling: ${transferName}`}
        description={
          <PoolingTaskDescription number={number} labware={labware} tasks={tasks} labwareState={labwareState} />
        }
      />
      {!runtimeMode && !readOnly && showEditButton && <TaskAction onEdit={onEdit} />}
      {isShowPipettingProfile && (
        <TaskPipettingProfileWrapper>
          <PoolingPipettingProfile task={tasks[0]} runtimeMode={runtimeMode} />
        </TaskPipettingProfileWrapper>
      )}
      {runtimeMode && executionStatus === ExecutionStatus.EXECUTING && <Spinner />}
      {runtimeMode && executionStatus === ExecutionStatus.EXECUTED && <TaskExecutedTick />}
    </TaskWrapper>
  );
}

PoolingTaskTransfer.propTypes = {
  disableDrag: PropTypes.bool,
  executionStatus: PropTypes.string.isRequired,
  isHighlighted: PropTypes.bool.isRequired,
  labware: PropTypes.object.isRequired,
  labwareState: PropTypes.object.isRequired,
  number: PropTypes.number.isRequired,
  readOnly: PropTypes.bool,
  runtimeMode: PropTypes.bool,
  showEditButton: PropTypes.bool,
  tasks: PropTypes.array.isRequired,
  onEdit: PropTypes.func,
  onShowMenuContext: PropTypes.func,
};

PoolingTaskTransfer.defaultProps = {
  disableDrag: false,
  readOnly: false,
  runtimeMode: false,
  showEditButton: false,
  onEdit: () => {},
  onShowMenuContext: () => {},
};

export default PoolingTaskTransfer;
